import Paper from '@material-ui/core/Paper';
import PropTypes from 'prop-types';
import React from 'react';
import { useAccordionListStateContext } from 'Components/UI/TabularAccordionList/AccordionListContext';
import { withStyles } from '@material-ui/core/styles';
import AccordionHeaderColumn from './AccordionHeaderColumn';
import { useColumnStyles } from './hooks';

function AccordionListHeader({ classes, collection }) {
  const { schema } = useAccordionListStateContext();
  const schemaEntries = Object.entries(schema);
  const columnStyles = useColumnStyles();
  return (
    <Paper className={classes.root} square>
      {schemaEntries.map(([name, { HeaderComponent }]) => {
        const sortable = collection?.meta().queries().index(0).field(name)
          ?.attr('sortable');
        return (
          <AccordionHeaderColumn key={`header-${name}`} className={columnStyles.col} attrName={name} orderable={sortable}>
            <HeaderComponent attrName={name} />
          </AccordionHeaderColumn>
        );
      })}
    </Paper>
  );
}

AccordionListHeader.propTypes = {
  classes: PropTypes.object.isRequired,
  collection: PropTypes.object.isRequired,
};

export default withStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    padding: theme.spacing(1, 6, 1, 0), // account for expanding icon
    paddingLeft: 32,
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.facet.lightGray,
  },
}))(AccordionListHeader);
